import * as _ from 'lodash';

export const mapBodyParams = (params) => {
  let mappedParams = {};

  _.forIn(params, (value, key) => {

    if (_.isPlainObject(params[key])) {
      value = mapBodyParams(params[key]);
    }

    if (_.isNull(value) || value.length === 0 || (
      _.isArray(value) && _.every(value, _.isNull)
    )) return;

    mappedParams[key] = value;
  });

  return mappedParams;
};


// WEBPACK FOOTER //
// ./src/utils/mapBodyParams.js